// image-utils.js - 이미지 관련 유틸리티
// Extracted from app.js

/**
 * 이미지 크기 가져오기
 * @param {string} dataURL
 * @returns {Promise<{ width: number, height: number }>}
 */
export function getImageSize(dataURL) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = () => resolve({ width: 0, height: 0 });
    img.src = dataURL;
  });
}

/**
 * 코너 좌표 스케일링 (비디오 → 캡처 이미지)
 * @param {Object} corners - 원본 코너 좌표
 * @param {{ width: number, height: number }} fromSize - 원본 크기
 * @param {{ width: number, height: number }} toSize - 대상 크기
 * @returns {Object} 스케일된 코너 좌표
 */
export function scaleCorners(corners, fromSize, toSize) {
  const scaleX = toSize.width / fromSize.width;
  const scaleY = toSize.height / fromSize.height;

  return {
    tl: { x: Math.round(corners.tl.x * scaleX), y: Math.round(corners.tl.y * scaleY) },
    tr: { x: Math.round(corners.tr.x * scaleX), y: Math.round(corners.tr.y * scaleY) },
    br: { x: Math.round(corners.br.x * scaleX), y: Math.round(corners.br.y * scaleY) },
    bl: { x: Math.round(corners.bl.x * scaleX), y: Math.round(corners.bl.y * scaleY) }
  };
}

/**
 * 이미지 로드 헬퍼
 * @param {string} dataURL
 * @returns {Promise<HTMLImageElement>}
 */
export function loadImage(dataURL) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('이미지 로드 실패'));
    img.src = dataURL;
  });
}

/**
 * Data URL에서 Blob 크기 추정
 * @param {string} dataURL
 * @returns {number} 추정 바이트 크기
 */
export function estimateBlobSize(dataURL) {
  const base64 = dataURL.split(',')[1];
  if (!base64) return 0;
  // Base64는 원본 대비 약 4/3 크기
  return Math.round(base64.length * 0.75);
}

/**
 * Canvas를 Data URL로 변환
 * @param {HTMLCanvasElement} canvas
 * @param {'png' | 'jpeg'} format
 * @param {number} quality - JPEG 품질 (0-1)
 * @returns {string}
 */
export function canvasToDataURL(canvas, format = 'jpeg', quality = 0.85) {
  return canvas.toDataURL(`image/${format}`, quality);
}
